import { type UseQueryResult, useQuery } from 'react-query';
import {
  DashboardService,
  // eslint-disable-next-line camelcase
  type Wealthlane_ReportService_Dtos_AuditTrailsDto,
} from '../../services/wealthlane-report-services';

const useGetReportParticipantDashboardDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_ReportService_Dtos_AuditTrailsDto[] | undefined,
  unknown
> => {
  const reportParticipantDashboardDetails = useQuery(
    ['getReportParticipantDashboardDetails'],
    async () => {
      return await handleRequest(
        DashboardService.getApiReportApiAppDashboardParticipantDashboard()
      );
    }
  );

  return reportParticipantDashboardDetails;
};

export default useGetReportParticipantDashboardDetails;
